import {createApp} from 'vue'
import FormInputDateField from './FormInputDateField'

const el = '.kb-component--form-input-date-field'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((FormInputDateFieldDOM)=>{
            const component = createApp(FormInputDateField).use(Store)
            component.mount(FormInputDateFieldDOM)
        })
    }
}